import { Injectable } from '@angular/core';
import { Event as RouterEvent, NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { FaroService } from './faro.service';

@Injectable({ providedIn: 'root' })
export class FaroRouterTrackerService {
  constructor(private router: Router, private faroService: FaroService) {}

  public initialize(): void {
    this.router.events
      .pipe(filter((event: RouterEvent): event is NavigationEnd => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        const name = event.urlAfterRedirects.split('?')[0].replace(/^\//, '') || '/';
        this.faroService.setView({ name });
      });
  }
}
